import { createAction } from '@reduxjs/toolkit';

import type { PriorityPresetsType } from 'src/components/Filters';

export const setFiltersPriorityPresetAction = createAction<PriorityPresetsType>(
  `view/setFiltersPriorityPreset`,
);
